import { render } from "./ManageCategories.vue?vue&type=template&id=943c1d58&scoped=true"
import script from "./ManageCategories.vue?vue&type=script&lang=js"
export * from "./ManageCategories.vue?vue&type=script&lang=js"

import "./ManageCategories.vue?vue&type=style&index=0&id=943c1d58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-943c1d58"]])

export default __exports__